var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 14.787C14.24 14.787 13.56 15.087 13.04 15.557L5.91 11.407C5.96 11.177 6 10.947 6 10.707C6 10.467 5.96 10.237 5.91 10.007L12.96 5.89703C13.5 6.39703 14.21 6.70703 15 6.70703C16.66 6.70703 18 5.36703 18 3.70703C18 2.04703 16.66 0.707031 15 0.707031C13.34 0.707031 12 2.04703 12 3.70703C12 3.94703 12.04 4.17703 12.09 4.40703L5.04 8.51703C4.5 8.01703 3.79 7.70703 3 7.70703C1.34 7.70703 0 9.04703 0 10.707C0 12.367 1.34 13.707 3 13.707C3.79 13.707 4.5 13.397 5.04 12.897L12.16 17.057C12.11 17.267 12.08 17.487 12.08 17.707C12.08 19.317 13.39 20.627 15 20.627C16.61 20.627 17.92 19.317 17.92 17.707C17.92 16.097 16.61 14.787 15 14.787Z",
    fill: "inherit"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.3cd4d0ae.svg";
export { ForwardRef as ReactComponent };